import CreateConsultingCompanyContainer from "./CreateConsultingCompanyContainer";
export default CreateConsultingCompanyContainer;
